import React from 'react';
import PropTypes from 'prop-types';

import { FixturesNav } from './FixturesNav';

export const Fixtures = (data) => {
    return (
        <>
            <FixturesNav {...data} />
        </>
    );
};

Fixtures.propTypes = {
    data: PropTypes.object
};
